"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Rating = void 0;
var Rating_1 = __importDefault(require("./Rating"));
exports.Rating = Rating_1.default;
exports.default = Rating_1.default;
//# sourceMappingURL=index.js.map